import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class DeadwoodRipGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_WAYS = "Font_Ways";
    static BITMAP_FONT_WAYS_COUNT_UP = "NumbersWaysCountUp";
    static BITMAP_FONT_NUDGE_MULTIPLIER = "NudgeMultipliers";
    static BITMAP_FONT_INTRO_NUMBER = "FSIntroNumber";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(DeadwoodRipGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(DeadwoodRipGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(DeadwoodRipGameAssets.BITMAP_FONT_WAYS, "fonts/bitmapfonts/Font_Ways.fnt"),
                    new BitmapFontAsset(DeadwoodRipGameAssets.BITMAP_FONT_WAYS_COUNT_UP, "fonts/bitmapfonts/NumbersWaysCountUp.fnt"),
                    new BitmapFontAsset(DeadwoodRipGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER, "fonts/bitmapfonts/NudgeMultipliers.fnt"),
                    new BitmapFontAsset(DeadwoodRipGameAssets.BITMAP_FONT_INTRO_NUMBER, "fonts/bitmapfonts/FSIntroNumber.fnt")
                ]
            },
            {
                name : "backgrounds",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json"),
                    new TextureAsset("backgroundsJpeg3", "sheets/backgroundsJpeg/backgroundsJpeg3.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("mainNoCompress0", "sheets/main/mainNoCompression0.json")
                ]
            },
            {
                name : "mainHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHigh0", "sheets/main/mainHigh0.json")
                ]
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json")
                ]
            },
            {
                name : "symbols",
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                animations : {}
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("frame", "spine/reelFrame.json"),
                    new SpineAsset("winHint", "spine/winHint.json"),
                    new SpineAsset("initialWin", "spine/initialWin.json"),
                    new SpineAsset("cylinder", "spine/cylinder.json"),
                    new SpineAsset("cylinderVFX", "spine/cylinderVFX.json"),
                    new SpineAsset("wxn", "spine/wxnNudge.json"),
                    new SpineAsset("S1", "spine/S1.json"),
                    new SpineAsset("S1_FS", "spine/S1_FS.json"),
                    new SpineAsset("S2", "spine/S2.json"),
                    new SpineAsset("S3", "spine/S3.json"),
                    new SpineAsset("shootOutWave", "spine/glow_underReel.json"),
                    new SpineAsset("WRS", "spine/WRS.json"),
                    new SpineAsset("bw1", "spine/bigWin/BW_L1.json"),
                    new SpineAsset("bw2", "spine/bigWin/BW_L2.json"),
                    new SpineAsset("bw3", "spine/bigWin/BW_L3.json"),
                    new SpineAsset("bw4", "spine/bigWin/BW_L4.json"),
                    new SpineAsset("bw5", "spine/bigWin/BW_L5.json"),
                    new SpineAsset("bw6", "spine/bigWin/BW_L6.json"),
                    new SpineAsset("bwEffect", "spine/bigWin/bwEffect.json"),
                    new SpineAsset("capWin", "spine/capWin.json"),
                    new SpineAsset("split", "spine/splitReel.json"),
                    new SpineAsset("introOutro", "spine/inOutro.json"),
                    new SpineAsset("mainIdleWeed", "spine/idle/tumbleWeed.json"),
                    new SpineAsset("mainIdleDust", "spine/idle/mainBgDust.json"),
                    new SpineAsset("nearWin", "spine/scatterAnticipation.json"),
                    new SpineAsset("bgEffect", "spine/BG.json"),
                    new SpineAsset("shootVFX", "spine/shootVFX.json")
                ]
            }
        ]
    };
}